export const classTypesBackgrounds = {
  "G&T": "#E4E9F4",
  BARRE: "#EFA2A4",
  SNB: "#4F2A3B",
  BBP: "#C8A0E8",
  JUMP: "#6B3440",
  CARDIO: "#FFB66B",
  MIX: "rgb(149,137,247)",
  KBPOWER: "#FFB66B",
};
